/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import axios from "axios";
import { Link } from "react-router-dom";
import { Trash, PencilSimpleLine } from "@phosphor-icons/react";
import api from "../../utils/api";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const SectionDetails = () => {
  const [fetchedData, setFetchedData] = useState([]);
  const [show, setShow] = useState(false);
  const [sectionName, setSectionName] = useState("");
  const [modules, setModules] = useState([]); // To hold modules for selection
  const [selectedModule, setSelectedModule] = useState(""); // To hold the selected module
  const [ID, setID] = useState(null);

  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10); // Customize the number of items per page
  const [totalItems, setTotalItems] = useState(0);
  const [loading, setLoading] = useState(false);

  const TableLoader = ({ rows = 10, columns = 10 }) => (
    <tbody>
      {Array.from({ length: rows }).map((_, rowIndex) => (
        <tr key={rowIndex}>
          {Array.from({ length: columns }).map((_, colIndex) => (
            <td key={colIndex} className="text-center">
              <div
                style={{
                  height: "20px",
                  backgroundColor: "#e0e0e0",
                  borderRadius: "20px",
                }}
              ></div>
            </td>
          ))}
        </tr>
      ))}
    </tbody>
  );

  async function fetchModules() {
    setLoading(true);
    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const token = localStorage.getItem("authToken");
      const programType = "getAllDetails";

      const fd = new FormData();
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("programType", programType);

      const response = await api.post("module/moduleCurl", fd);
      // console.log("Response m:", response.data);

      if (response.data && Array.isArray(response.data.getResponse)) {
        setModules(response.data.getResponse);
        // console.log('Modules:', response.data.getResponse); // Debug line
      } else {
        setFetchedData([]);
        setTotalItems(0);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setFetchedData([]);
      setModules([]);
    } finally {
      setLoading(false);
    }
  }

  // Fetch the module data from the API
  async function fetchData(page = 1) {
    setLoading(true);
    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const token = localStorage.getItem("authToken");
      const programType = "getSectionDetails";

      const fd = new FormData();
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("programType", programType);
      fd.append("page", page);
      fd.append("limit", itemsPerPage);

      const response = await api.post("section/sectionCurl", fd);
      // console.log("Response data:", response.data);

      if (response.data && Array.isArray(response.data.getResponse)) {
        setFetchedData(response.data.getResponse);
        setCurrentPage(page);
        setTotalItems(response.data.totalPages * itemsPerPage); // Derive totalItems from totalPages
      } else {
        setFetchedData([]);
        setTotalItems(0);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setFetchedData([]);
      setModules([]);
    } finally {
      setLoading(false);
    }
  }

  // Handle course submission (add or update)
  async function handleSubmit(e) {
    e.preventDefault();

    const loggedInUser = localStorage.getItem("loggedInUser");
    const token = localStorage.getItem("authToken");
    const programType = ID ? "updateSection" : "addSection"; // Different action for update or add

    const fd = new FormData();
    fd.append("programType", programType);
    fd.append("loggedInUser", loggedInUser);
    fd.append("token", token);

    fd.append("class", selectedModule); // Send the selected module ID
    fd.append("sectionName", sectionName); // Send the course name

    // Only append 'id' if it exists (for updating)
    if (ID) {
      fd.append("id", ID);
    }

    // Log FormData to check its contents before sending
    for (let pair of fd.entries()) {
      // console.log(pair[0] + ": " + pair[1]);
    }

    try {
      const response = await api.post("section/sectionCurl", fd);
      // console.log(response.data);

      // console.log("Form data:", {
      //   selectedModule,
      //   sectionName,
      // });
      toast.success("Section added successfully");
      fetchData(); // Refresh the data after submitting
      setShow(false); // Close the modal
      setSectionName(""); // Reset course name
      setSelectedModule(""); // Reset selected module
      setID(null); // Reset ID
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  }

  // Delete course functionality
  async function handleDelete(id) {
    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const token = localStorage.getItem("authToken");
      const programType = "deleteSection";

      const fd = new FormData();
      fd.append("programType", programType);
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("id", id);

      const response = await api.post("section/sectionCurl", fd);
      // console.log("Delete response:", response);
      if (response.data && response.data.message) {
        // console.log(response.data.message);
        toast.success("Section deleted successfully");
      } else {
        toast.success("Section deleted successfully");
        console.error("Failed to delete the module. Response:", response);
      }

      // Refresh the data after deletion
      fetchData(); // This will update the list of courses
    } catch (error) {
      console.error("Error deleting module:", error);
    }
  }

  // Open modal to add a new course
  const handleShowAdd = () => {
    setSectionName("");
    setSelectedModule(""); // Reset selected module
    setID(null); // No ID for new course
    setShow(true); // Open modal
  };

  // Open modal to edit an existing course
  // const handleShowEdit = (section) => {
  //   setSectionName(section.sectionName);
  //   setSelectedModule(section.moduleId); // Set the selected module ID to course.moduleId
  //   setID(section.id); // Set ID for editing
  //   setShow(true);
  // };

  async function handleShowEdit  (section)  {
    // console.log("section Data: ", section.id);
    const loggedInUser = localStorage.getItem("loggedInUser");
    const token = localStorage.getItem("authToken");
    const programType = "getDetailsForUpdate";
  
    const fd = new FormData();
    fd.append("programType", programType);
    fd.append("loggedInUser", loggedInUser);
    fd.append("token", token);
    fd.append("id", section.id); // Send chapter ID to fetch details for editing
  
    try {
      const response = await api.post("section/sectionCurl", fd);
      // console.log("Response from API:", response);
  
      if (response.data && response.data.getResponse) {
        const sectionDetails = response.data.getResponse[0]; // Assuming the response is an array of chapter details
        // Prefill the form fields
        setSelectedModule(sectionDetails.classId);
       // Make sure this is set
        setID(sectionDetails.id); // Set ID for editing
        setShow(true); // Show the modal
      }
    } catch (error) {
      console.error("Error fetching chapter details:", error);
    }
    setSectionName(section.sectionName);
    setID(section.id);
    setShow(true);
  };

  // Close modal
  const handleClose = () => {
    setShow(false);
    setSectionName(""); // Reset the form data
    setID(null); // Reset ID
  };

  // Pagination logic
  // Pagination logic
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      fetchData(page);
    }
  };

  // Fetch data when the component mounts
  useEffect(() => {
    fetchData();
    fetchModules();
  }, []);

  const mystyle = {
    marginTop: "20px",
    display: "flex",
    justifyContent: "space-between",
  };

  const mystyle1 = {
    marginTop: "15px",
    // display: "flex",
    // justifyContent: "space-between",
  };

  return (
    <div className="dashboard-body">
      {/* Breadcrumb */}
      {/* Breadcrumb */}
      <div className="breadcrumb-with-buttons mb-24 flex-between flex-wrap gap-8">
        <div className="breadcrumb mb-24">
          <ul className="flex-align gap-4">
            <li>
              <Link
                to="/"
                className="text-gray-200 fw-normal text-15 hover-text-main-600"
              >
                Home
              </Link>
            </li>
            <li>
              <span className="text-gray-500 fw-normal d-flex">
                <i className="ph ph-caret-right"></i>
              </span>
            </li>
            <li>
              <span className="text-main-600 fw-normal text-15">
                Section Details
              </span>
            </li>
          </ul>
        </div>

        <div className="flex-align gap-8 flex-wrap">
          <div className="flex-align gap-8 flex-wrap">
            {/* <div class="position-relative text-gray-500 flex-align gap-4 text-13">
              <span class="text-inherit">Sort by: </span>
              <div class="flex-align text-gray-500 text-13 border border-gray-100 rounded-4 ps-20 focus-border-main-600 bg-white">
                <span class="text-lg">
                  <i class="ph ph-funnel-simple"></i>
                </span>
                <select class="form-control  mb-5 border-0 text-inherit rounded-4 text-center">
                  <option value="1" selected>
                    Popular
                  </option>
                  <option value="1">Latest</option>
                  <option value="1">Trending</option>
                  <option value="1">Matches</option>
                </select>
              </div>
            </div>
            <div class="flex-align text-gray-500 text-13 border border-gray-100 rounded-4 ps-20 focus-border-main-600 bg-white">
              <span class="text-lg">
                <i class="ph ph-layout"></i>
              </span>
              <select
                class="form-control mb-5 border-0 text-inherit rounded-4 text-center"
                id="exportOptions"
              >
                <option value="" selected disabled>
                  Export
                </option>
                <option value="csv">CSV</option>
                <option value="json">JSON</option>
              </select>
            </div> */}
            <button
              onClick={handleShowAdd}
              className="btn btn-lg btn-main mt-0 "
            >
              Add Section
            </button>
          </div>
        </div>
      </div>

      {/* Modules Table */}
      <div className="card mt-24">
        <div
          className="card-header table-responsive"
          style={{ padding: "10px" }}
        >
          <table id="assignmentTable" className="table table-striped dataTable">
            <thead>
              <tr>
                <th className="h5 text-gray-300" scope="col">
                  ID
                </th>
                <th className="h5 text-gray-300" scope="col">
                  Section Name
                </th>
                <th className="h5 text-gray-300" scope="col">
                  Class Name
                </th>
                <th className="h5 text-gray-300" scope="col">
                  Action
                </th>
              </tr>
            </thead>
            {loading ? (
              <TableLoader rows={6} columns={5} /> // Show custom loader
            ) : (
              <tbody>
                {fetchedData.map((section, index) => (
                  <tr key={section.id}>
                    <td className="h6 mb-0 fw-medium text-gray-300">
                      {(currentPage - 1) * itemsPerPage + index + 1}
                    </td>
                    <td className="h6 mb-0 fw-medium text-gray-300">
                      {section.sectionName}
                    </td>
                    <td className="h6 mb-0 fw-medium text-gray-300">
                      {section.moduleName}
                    </td>
                    <td className="g-2">
                      <button onClick={() => handleShowEdit(section)}>
                        <PencilSimpleLine size={22} color="#00945b" />
                      </button>
                      &nbsp; &nbsp;
                      <button onClick={() => handleDelete(section.id)}>
                        <Trash size={22} color="#c70000" />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            )}
          </table>
        </div>

        {/* {/* Pagination */}
        <div className="card-footer flex-between flex-wrap">
          <span>
            {fetchedData.length > 0
              ? `Showing ${(currentPage - 1) * itemsPerPage + 1} to ${
                  (currentPage - 1) * itemsPerPage + fetchedData.length
                }`
              : "No entries to show"}
          </span>
          <ul className="pagination">
            {Array.from({ length: totalPages }, (_, index) => (
              <li
                key={index}
                className={`page-item ${
                  currentPage === index + 1 ? "active" : ""
                }`}
              >
                <button
                  className="page-link h-44 w-44 flex-center text-15 rounded-8 fw-medium"
                  onClick={() => handlePageChange(index + 1)}
                >
                  {index + 1}
                </button>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <ToastContainer />

      {/* Modal for adding/editing modules */}
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>{ID ? "Edit Section" : "Add New Section"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handleSubmit} id="section-deatils-form">
            <div className="mb-3">
              <label htmlFor="moduleName" className="form-label mb-8 h6">
                Select Class  <span style={{ color: "red" }}>*</span>
              </label>
              <select
                className="form-control fw-medium"
                value={selectedModule}
                onChange={(e) => setSelectedModule(e.target.value)}
              >
                <option value="">Select a Class</option>
                {modules && modules.length > 0 ? (
                  modules.map((module) => (
                    <option key={module.id} value={module.id}>
                      {module.moduleName}
                    </option>
                  ))
                ) : (
                  <option value="">No Classes Available</option>
                )}
              </select>
            </div>

            <div className="" style={mystyle1}>
              <label htmlFor="sectionName" className="form-label mb-8 h6">
                Enter Section  <span style={{ color: "red" }}>*</span>
              </label>
              <input
                type="text"
                className="form-control fw-medium"
                placeholder="Enter Section "
                id="sectionName"
                name="sectionName"
                value={sectionName}
                onChange={(e) => setSectionName(e.target.value)}
                required
              />
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="btn btn-outline-main bg-main-100 border-main-100 text-main-600 rounded-pill py-9"
            variant="secondary"
            onClick={handleClose}
          >
            Cancel
          </Button>
          <button
            form="section-deatils-form"
            variant="primary"
            type="submit"
            className="btn btn-main rounded-pill py-9"
          >
            {ID ? "Update Section" : "Add Section"}
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default SectionDetails;
